import ActionType from 'actions/ActionType'
import { omit } from 'lodash'

export default (state = { email: { required: true, idx: 0 } }, action) => {
	switch (action.type) {
		case ActionType.SignupForm.HANDLE_FORM_FIELD_CHANGE:
			if (state[action.payload]) {
				if (
					action.payload === 'email' &&
					(!state.phone || !state.phone.required)
				) {
					return omit(
						{ ...state, phone: { ...state.phone, required: true } },
						'email',
					)
				}
				if (
					action.payload === 'phone' &&
					(!state.email || !state.email.required)
				) {
					return omit(
						{ ...state, email: { ...state.email, required: true } },
						'phone',
					)
				}
				return omit(state, action.payload)
			}
			return {
				...state,
				[action.payload]: { required: false, idx: Object.keys(state).length },
			}
		case ActionType.SignupForm.HANDLE_FORM_DRAG:
			return {
				...action.payload.reduce((obj, item, idx) => {
					obj[item.name] = { required: item.required, idx }
					return obj
				}, {}),
			}
		case ActionType.SignupForm.FORM_FIELD_REQUIRED_CHANGE:
			if (state[action.payload].required) {
				if (
					action.payload === 'email' &&
					(!state.phone || !state.phone.required)
				) {
					return {
						...state,
						email: { required: false },
						phone: { required: true },
					}
				}
				if (
					action.payload === 'phone' &&
					(!state.email || !state.email.required)
				) {
					return {
						...state,
						email: { ...state.email, required: true },
						phone: { ...state.phone, required: false },
					}
				}
			}
			return {
				...state,
				[action.payload]: { required: !state[action.payload].required },
			}
		case ActionType.SignupForm.RECEIVE_FORM:
			if (action.payload) {
				return action.payload.contact_fields.reduce((newState, field, idx) => {
					newState[field.field_name] = { required: field.required, idx }
					return newState
				}, {})
			}
			return { email: { required: true, idx: 0 } }
		default:
			return state
	}
}
